import Typography from '@mui/material/Typography';


export default function InfoWatchlistText() {
  
  return (
<div>
    
<Typography variant="h6" >

Newborn screening is a critical public health program designed to identify serious health conditions in babies shortly after birth. 
It aims to find those few babies who might have a condition and connect them with early care, treatment, and intervention — 
giving them the best possible chance at a healthy life.<br /><br />  
Health care providers cannot always detect serious conditions in newborns just by physical examination. 
Many babies born with a condition have no family history and appear completely healthy at birth. 
Newborn screening is often the only way to detect these conditions before symptoms appear. Early detection and intervention can significantly improve health outcomes, developmental progress, and quality of life.
<br /><br />  
In this section, your genome was scanned for genetic variants associated with conditions included in the Recommended Uniform Screening Panel (RUSP). 
These conditions are known to typically present early in life and benefit from early detection, monitoring, or treatment.
<br /><br />  
How to Read Your Results:<br /><br /> 
 Green color: No disease-associated variants were found.<br /> 
 Blue color: A variant with 'uncertain significance' was found in a gene linked to a disease phenotype.<br /> 
 Red color: A 'pathogenic' or 'likely pathogenic' variant was found in a gene linked to a disease phenotype.
 <br /><br /> 
Important:<br /> <br /> 
These results should always be discussed with your pediatrician or genetic counselor. 
Early medical consultation is key if any variants are found, even if there are no symptoms yet.
<br /> <br /> 

</Typography>    
</div>

   )
}